import { createApp } from 'vue';
import App from './App.vue';
import { createMetaManager, plugin as metaPlugin } from 'vue-meta';
import '@/assets/tailwind.css';
import { store } from '@/store';
import VueScrollTo from 'vue-scrollto';
import apiUrl from '@/apiUrl';
import router from '@/router';
import _ from 'lodash';
import moment from 'moment';
import DOMPurify from 'dompurify';
import axios from '@/utils/axios';
import { Form, Field, ErrorMessage } from '@/utils/validate.js';
import dateTransform from '@/utils/dateTransform';
import insurance from '@/utils/insurance';
import monetary from '@/utils/monetary';
import auth from '@/utils/auth';
import browser from '@/utils/browser';
import tel from '@/utils/tel';
import maintain from '@/utils/maintain';
import idle from '@/utils/idle';
import character from '@/utils/character';
import taiwanId from '@/utils/taiwanId';
import { uppercase, trim, clickOutside } from '@/utils/directives';
import ga from '@/utils/ga';
import member from '@/utils/member';
import review from '@/utils/review';
import terms from '@/utils/terms';
import VueCookies from 'vue-cookies';
import log from '@/utils/log';
import cryptojs from '@/utils/cryptojs';
import verificationCode from '@/utils/verificationCode';
import EsunWallet from '@/utils/esunwallet';
import payment from '@/utils/payment';

window.axios = axios;
window.apiUrl = apiUrl;
window.DOMPurify = DOMPurify;
window._ = _;
window.EsunWallet = EsunWallet;

const app = createApp(App);
app.use(VueScrollTo);
app.use(metaPlugin, {keyName: 'metaInfo'}).use(createMetaManager());
app.use(router);
app.use(store);
app.use(VueCookies);

app.component('VeeForm', Form);
app.component('VeeField', Field);

//f12 能看到vuex store 
app.config.devtools = true;

// productionTip 設為 false，阻止 vue 啟動時產生的提示訊息
app.config.productionTip = false;
app.config.globalProperties.$moment = moment;
app.config.globalProperties.$dateTransform = dateTransform;
app.config.globalProperties.$insurance = insurance;
app.config.globalProperties.$monetary = monetary;
app.config.globalProperties.$auth = auth;
app.config.globalProperties.$browser = browser;
app.config.globalProperties.$tel = tel;
app.config.globalProperties.$maintain = maintain;
app.config.globalProperties.$idle = idle;
app.config.globalProperties.$character = character;
app.config.globalProperties.$taiwanId = taiwanId;
app.config.globalProperties.$ga = ga;
app.config.globalProperties.$member = member;
app.config.globalProperties.$review = review;
app.config.globalProperties.$terms = terms;
app.config.globalProperties.$log = log;
app.config.globalProperties.$cryptojs = cryptojs;
app.config.globalProperties.$verificationCode = verificationCode;
app.config.globalProperties.$payment = payment;

app.directive('uppercase', uppercase);
app.directive('trim', trim);
app.directive('click-outside', clickOutside);


router.isReady().then(() => app.mount('#app'));